export const nbspToSpace = (value: string) => {
  return value.replace(/&nbsp;/gi, ' ').replace(/\u00A0/g, ' ')
}
